import { create } from 'zustand';

type SaintPatrickModalState = {
	isOpen: boolean;
	setOpen: (open: boolean) => void;
	open: () => void;
	close: () => void;
};

export const useSaintPatrickModalStore = create<SaintPatrickModalState>((set) => ({
	isOpen: false,
	setOpen: (open) => set({ isOpen: open }),
	open: () => set({ isOpen: true }),
	close: () => set({ isOpen: false }),
}));
